import React from 'react'
import { connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import store from '../../../redux/stores/store'
import './menu.scss'
import Item from './item/item.component'
import { MENU_ACTIVE_ITEM, MENU_TOGGLE } from '../../../redux/reducers/menu/action-types'
import iconLogo from '../../../assets/images/logo.png'
import AuthHelper from '../../../utils/AuthHelper'

class Menu extends React.Component {

    constructor(props){
        super(props)
        this.state = {...props.menu}
    }

    componentDidMount = () => {
        this.unsubscribe = store.subscribe(() => {
            this.setState(store.getState().menu)
        })
        this.setActiveItem()
    }

    onItemClick = (key) => {
        key === 0 && this.props.history.push('/')
        this.props.dispatch({
            type: MENU_ACTIVE_ITEM,
            payload: {
                key: key
            }
        })
    }

    setActiveItem = () => {
        this.state.items.forEach((item, key) => {
            item.subItems.forEach(subItem => {
                let paths = this.props.location.pathname.split('/')
                paths.length > 2 && subItem.url.includes(paths[1]+"/"+paths[2]) && key !== this.state.activeItem && this.onItemClick(key)
            })
        })
    }

    onSubItemClick = url => {
        if(this.props.location.pathname === url){
            window.location.reload()
            return
        }
        this.props.dispatch({
            type: MENU_TOGGLE,
            payload:{}
        })
    }

    componentWillUnmount = () => {
        this.unsubscribe()
    }

    getFilteredMenuByAuth = () => this.props.menu.items.filter(item => {
        if(item.permissions.length === 0){
            return true
        }
        return AuthHelper(this.props.auth).hasPermission(item.permissions)
    })

    render(){
        return(
            <div className={this.state.showMenu? 'menu active': 'menu'}>
                <h1>
                    <img src={iconLogo} alt=""/>
                </h1>
                <div className="space"></div>
                <ul>
                    {
                        this.getFilteredMenuByAuth().map(
                            (menu, key) => <Item key={key} active={(this.state.activeItem === key)} onClick={() => this.onItemClick(key)} onSubItemClick={this.onSubItemClick} {...menu}/>
                        )
                    }
                </ul>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        menu: state.menu,
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Menu))